import React from 'react';
import { Tooltip } from 'react-tooltip';
import HelpCircle from 'src/app/icons/Monospaced/HelpCircle/HelpCircle';
import { HelpCircleHintContainer } from './HelpCircleHint.styles';
import { useTranslation } from 'src/hooks/useTranslation';

interface HelpCircleHintProps {
  hint: string;
  id: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  color?: string;
}

const HelpCircleHint = ({ hint, id, placement = 'left', color }: HelpCircleHintProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <HelpCircleHintContainer
      justify='center'
      align='center'
    >
      <Tooltip
        id={id}
        className='label-tooltip'
      />
      <a
        data-tooltip-id={id}
        data-tooltip-html={`<p class="tooltip-text">${t(hint)}</p>`}
        data-tooltip-place={placement}
        className='tooltip-anchor'
      >
        <HelpCircle color={color} />
      </a>
    </HelpCircleHintContainer>
  );
};

export default HelpCircleHint;
